import { render, staticRenderFns } from "./XzqxStudent.vue?vue&type=template&id=90b6e128&scoped=true&"
import script from "./XzqxStudent.vue?vue&type=script&lang=js&"
export * from "./XzqxStudent.vue?vue&type=script&lang=js&"
import style0 from "./XzqxStudent.vue?vue&type=style&index=0&id=90b6e128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b6e128",
  null
  
)

export default component.exports